import {inject} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot} from '@angular/router';
import {AuthStore} from "./auth.store";

export const hasPermissionGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const authService = inject(AuthStore);
  if (route.data['requiredPermissions']) {
    return authService.hasAllPermissions(route.data['requiredPermissions']);
  } else if (route.data['requiredSomePermissions']) {
    return authService.hasSomePermissions(route.data['requiredSomePermissions']);
  }
  return Promise.resolve(true);
};
